import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Materials_ds_measurement_units_ddService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { typeId?: number, fullTextSearch?: string }): 
  Promise<{ result: { Id?: number, Name?: string, Short_name?: string }[] }> 
  {
    let url = `${environment.backendUrl}api/Materials/datasources/ds_measurement_units_dd/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { typeId?: number, fullTextSearch?: string, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, Name?: string, Short_name?: string }[], totalCount: number }> 
  {
    let url = `${environment.backendUrl}api/Materials/datasources/ds_measurement_units_dd/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { typeId?: number, fullTextSearch?: string, $keys: number[] }): 
  Promise<{ result: { Id?: number, Name?: string, Short_name?: string }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Materials/datasources/ds_measurement_units_dd/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      typeId?: number, fullTextSearch?: string    }) {
      return false;
    }
}
